import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useMemo, useRef, useState } from 'react';

import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import Slider, { Direction } from '@swf/components/Slider/Slider';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import { PASSES_TITLE_TRANSLATIONS } from '../../constants';
import type { PassTypeKey } from '../../types';

import styles from './PassListSlider.scss';

interface Props {
  type: PassTypeKey;
}

const PassListSlider = ({ type, children }: React.PropsWithChildren<Props>) => {
  const [sliderState, setSliderState] = useState<SliderState>({ left: false, right: false });
  const sliderRef = useMemo(() => React.createRef<SliderHandles>(), []);
  const innerRef = useRef<HTMLDivElement>(null);

  const onDirection = (direction: Direction) => {
    sliderRef.current?.scroll(direction);
  };

  return (
    <div className={styles.container} data-testid={`row-container-${type}`}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <Translation tagName="span" {...PASSES_TITLE_TRANSLATIONS[type]} />
        </h2>
        <div className={styles.buttons}>
          <StarsButton
            data-testid="nav-left"
            className={styles.button}
            onClick={() => onDirection(Direction.LEFT)}
            disabled={!sliderState.left}
            variant="casino"
            icon={<Arrow />}
            size="small"
          />
          <StarsButton
            data-testid="nav-right"
            className={classNames(styles.button, styles.right)}
            onClick={() => onDirection(Direction.RIGHT)}
            disabled={!sliderState.right}
            variant="casino"
            icon={<Arrow />}
            size="small"
          />
        </div>
      </div>
      <Slider
        innerClassName={styles.slider}
        onScroll={setSliderState}
        ref={sliderRef}
        innerRef={innerRef}
      >
        {children}
      </Slider>
    </div>
  );
};

export default PassListSlider;
